import fr from 'locales/fr';
import gb from 'locales/gb';

const locales = {
    gb,
    fr,
};

export default locales;
